import {Injectable} from '@angular/core';
import {TutorialState} from '../modules/akita-mimic/models/store-states/tutorial-state.model';
import {StoreService} from '../modules/akita-mimic/services/store.service';


@Injectable({ providedIn: 'root' })
export class TutorialStore extends StoreService<TutorialState> {

    public constructor() {
        super('tutorial', {
            isHidden: false,
            readTutorialStepIds: [],
        });
    }
}
